export const pages = {
	login: "/login",
	logout: "/logout",
	home: "/",
	bays: "/bays",
	freezers: "/freezers",
	containers: "/containers",
	playground: "/playground",
};
